import React, { FC } from "react";
import { Form, Input } from "antd";
import { Col, Row } from "antd";
import { DatePicker } from "antd";

type ReferralDetailsEchsProps = {
  form: any;
};

const ReferralDetailsEchs: FC<ReferralDetailsEchsProps> = ({
  form,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        REFERRAL DETAILS
      </div>

      <Form
        form={form}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%", }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Reference Number" name="referralNo">
              <Input disabled={true} style={{color: "black"}}/>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Issued Date" name="referralExpiryFrom">
              <Input disabled={true} style={{color: "black"}}/>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Validity Upto" name="referralExpiryTo">
              <Input disabled={true} style={{color: "black"}}/>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="No. Of Visits" name="noOfVisits">
              <Input disabled={true} style={{color: "black"}}/>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Admission" name="admission">
              <Input disabled={true} style={{color: "black"}}/>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Investigation" name="investigation">
              <Input disabled={true} style={{color: "black"}}/>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Consultation" name="consultationFor">
              <Input disabled={true} style={{color: "black"}}/>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="PolyClinic" name="polyClinic">
              <Input disabled={true} style={{color: "black"}}/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ReferralDetailsEchs;
 